import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { manual, Vessel, VesselsService } from '../../vessels.service';
import { DocumentReference } from 'src/app/documents/documents.service';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { MatButtonModule } from '@angular/material/button';
import { MaterialPdfViewerPopUpComponent } from 'src/app/shared/components/material-pdf-viewer-pop-up/material-pdf-viewer-pop-up.component';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { Versioned } from 'src/app/shared/helpers/versioned';
import { Manual } from 'src/app/generated/services/transportation/vessels/vessel';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';

@Component({
  selector: 'app-vessel-manuals',
  templateUrl: './vessel-manuals.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MatSelectModule,
    MatInputModule,
    MaterialChunkFileUploadComponent,
    MatButtonModule,
    MaterialPdfViewerPopUpComponent,
    MaterialPgInputComponent,
    MaterialAutoCompleteComponent
  ]
})
export class VesselManualComponent implements OnInit {
  versionedVessel!: Versioned<Vessel>;
  manual = Manual.create();

  showManualDoc!: boolean[];
  manuals: manual[] = [];
  doc?: DocumentReference;
  typeList: string[] = ['Manual', 'Drawing'];

  constructor(
    private _activateRoute: ActivatedRoute,
    private _vesselsService: VesselsService,
    private _messageService: PgMessagesService,
  ) { }

  ngOnInit(): void {
    this._activateRoute.params.subscribe(params => {
      if (params['imo']) {
        this._vesselsService.getVessel(params['imo']).subscribe(v => {
          if (v) {
            this.versionedVessel = v;
            this.manuals = this.versionedVessel.data!.spec!.manuals || [];
            this.showManualDoc = (this.versionedVessel.data!.spec!.manuals) ? this.versionedVessel.data!.spec!.manuals.map(() => false) : [];
          }
        });
      }
    });
  }

  pdfFileUploaded(fileId: DocumentReference): void {
    this.manual.fileId = fileId.id;
  }

  addManual() {
    if (!this.versionedVessel.data!.spec!.manuals) {
      this.versionedVessel.data!.spec!.manuals = [];
    }

    const index = this.versionedVessel.data!.spec!.manuals.findIndex(m =>
      m.name === this.manual.name &&
      m.manualType === this.manual.manualType);

    if (index >= 0) {
      this.versionedVessel.data!.spec!.manuals[index] = this.manual;
    } else {
      this.versionedVessel.data!.spec!.manuals.push(this.manual);
    }

    this._vesselsService.updateVessel(this.versionedVessel).subscribe((v) => {
      this._messageService.publishMessage({
        message: `${this.manual.manualType} added to vessel ${this.versionedVessel.data!.name!.name}`,
        level: MessageLevel.Info,
        topic: 'Manuals & Drawings'
      });
      this.versionedVessel = v;

      this.manual.manualType = '';
      this.manual.name = '';
      this.manual.fileId = '';
    }, () => {
      this._messageService.publishMessage({
        message: 'Error saving manual to vessel.',
        level: MessageLevel.Error,
        topic: 'Manuals & Drawings'
      });
    });
  }
  typeFormatter(type: string): string {
    return type === 'Manual' ? 'Manual' : 'Drawing';
  }

}
